// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['peopleCulture']


const DEFAULT_URL = '/cadastro-feriado'

const feriadoBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Feriado',
    to: 'feriado'
  }
]

export default [
  {
    path: `${DEFAULT_URL}`,
    name: 'feriado',
    component: () => import('@/views/Feriados/FeriadosListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Feriado',
      breadcrumb: feriadoBreadCrumb
    }
  },
  {
    path: `${DEFAULT_URL}/novo`,
    name: 'FeriadoNovo',
    component: () => import('@/views/Feriados/NovoFeriadoPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Novo Feriado',
      breadcrumb: [
        ...feriadoBreadCrumb,
        {
          label: 'Novo Feriado',
          to: 'FeriadoNovo'
        }
      ]
    }
  },
  {
    path: `${DEFAULT_URL}/:id/edit`,
    name: 'FeriadoEdit',
    component: () => import('@/views/Feriados/NovoFeriadoPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Detalhes',
      breadcrumb: [
        ...feriadoBreadCrumb,
        {
          label: 'Novo Feriado',
          to: 'FeriadoNovo'
        }
      ]
    }
  }
]
